import { createLogger } from '@superbet-group/web.lib.vue-utilities';

import { commonConfig as config } from '@src/config/common';

export const ticketLogger = createLogger({
    dsn: 'https://caa573f490f640b9a0b0bebe3a99584b:fd973c373a8d457ab08b8ffd7f3638e7@o139620.ingest.sentry.io/4504298299064320',
    sampleRate: 0.01,
    environment: config.environment.name,
    version: config.environment.version,
    isProduction: config.environment.isProduction,
    isTest: config.environment.isTest,
});
